import { render } from "./ListeTransaction.vue?vue&type=template&id=bb4e943c"
import script from "./ListeTransaction.vue?vue&type=script&lang=js"
export * from "./ListeTransaction.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Sekou A Sidibe\\Documents\\NTA TECH\\projets\\backoffice_operation_mouton\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__